import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withRouter } from "../../utils/router";
import { apiUrl } from "../../utils/apiUrl";
import Form from "./Form";
import Loader from "../general/Loader";
import { getLink, toast } from "../../utils/helpers";
import { postRequest } from "../../utils/request";

class Edit extends Component {
    state = {
        saving: false,
        errors: {},
    };
    updateVehiculo = async (event) => {
        event.preventDefault();
        this.setState({ saving: true });

        const data = new FormData(event.target);

        const id = this.props.match.params.id;
        const url = "vehiculos/" + id;

        const response = await postRequest(apiUrl(url), data);

        if (response.success) {
            this.props.history.push(getLink("/vehiculos"));
            toast("Vehiculo actualizado correctamente.");
        } else {
            toast("No se pudo actualizar el vehiculo.");
        }
        if (response.code === 422) {
            this.setState({ errors: response.data.message });
        }

        this.setState({ saving: false });
    };
    deleteVehiculo = async (event, vehiculo) => {
        event.preventDefault();

        const url = `vehiculos/${vehiculo}`;
        const response = await postRequest(apiUrl(url), {}, 'delete');

        if (response.success) {
            this.props.history.push(getLink("/vehiculos"));
            toast("Vehiculo borrado.");
            return;
        } else {
            toast(
                "No se pudo borrar el vehiculo. Revisa que no tenga gastos o tarjetas asignadas.",
                "error"
            );
        }
    };
    render() {
        const { errors, saving } = this.state;
        const { vehiculo, categorias, choferes } = this.props;
        return (
            <div>
                {!vehiculo.ficha ? (
                    <Loader />
                ) : (
                    <form
                        method='post'
                        onSubmit={this.updateVehiculo}
                        encType='multipart/form-data'>
                        <input type='hidden' name='_method' value='patch' />
                        <Form
                            vehiculo={vehiculo}
                            errors={errors}
                            categorias={categorias}
                            choferes={choferes}
                        />
                        <div className='page-footer text-right'>
                            <button
                                type='button'
                                className='btn float-left'
                                onClick={(e) =>
                                    this.deleteVehiculo(e, vehiculo.id)
                                }>
                                <i className='fas fa-trash-alt'></i>
                            </button>
                            <Link
                                to={getLink("/vehiculos")}
                                className='btn btn-plain'>
                                Cancelar
                            </Link>
                            {saving ? (
                                <Loader type='small' />
                            ) : (
                                <button
                                    type='submit'
                                    className='btn btn-primary'>
                                    Guardar
                                </button>
                            )}
                        </div>
                    </form>
                )}
            </div>
        );
    }
}

export default withRouter(Edit);
